import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Reconciliation = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec my-3">
                  <div className="row justify-content-between align-items-center">
                    <div className="col-md-4">
                      <h4 className="event-alert br-btm-0">
                        Bank Accounts
                        <div className="clear"></div>
                      </h4>
                    </div>

                    <div className="col-lg-2 col-md-4 align-right">
                      <div className="field text-right">
                        <button
                          class="btn green-btn-revert upload-icon mx-0"
                          id="addCount"
                          type="button"
                        >
                          <i class="i-icon"> </i> Upload
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0 custom_div_quest defulat_customs">
              <div class="col-lg-6 col-sec col-12">
                <a href="/finance_summary/reconciles/40391">
                  <div class="csutom_div">
                    <h5>UOB Checking - HQ</h5>
                  </div>
                  <div class="csutom_div align-right">
                    <label class="big-text block">
                      Status: <span class="blue_text">Unmatched</span>
                    </label>
                    <label class="small-text block">
                      No uploads for account yet
                    </label>
                  </div>
                  <hr class="bank" />
                  <div class="csttom_1">
                    <div class="balan1 minheight">
                      <span class="block">Bank Balance: $0.00</span>
                      <span class="block">GM Balance: $32,859.46</span>
                    </div>
                    <div class="balan2">
                      <label>
                        Break: <span class="yellow_text">$32,859.46</span>
                      </label>
                      <label class="small-text block">
                        No uploads for account yet
                      </label>
                    </div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">Pending Approvals</div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">
                      Unmatched <br />
                      Incoming
                    </div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">
                      Unmatched Outgoing <br />
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-lg-6 col-sec col-12 mt-3 mt-lg-0">
                <a href="/finance_summary/reconciles/44036">
                  <div class="csutom_div">
                    <h5>SCB Checking</h5>
                  </div>
                  <div class="csutom_div align-right">
                    <label class="big-text block">
                      Status: <span class="blue_text">Unmatched</span>
                    </label>
                    <label class="small-text block">
                      No uploads for account yet
                    </label>
                  </div>
                  <hr class="bank" />
                  <div class="csttom_1">
                    <div class="balan1 minheight">
                      <span class="block">Bank Balance: $0.00</span>
                      <span class="block">GM Balance: $0.00</span>
                    </div>
                    <div class="balan2">
                      <label>
                        Break: <span class="yellow_text">$0.00</span>
                      </label>
                      <label class="small-text block">
                        No uploads for account yet
                      </label>
                    </div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">Pending Approvals</div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">
                      Unmatched <br />
                      Incoming
                    </div>
                  </div>
                  <div class="csttom_2">
                    <div class="height_diuv">0</div>
                    <div class="status_height">
                      Unmatched Outgoing <br />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Reconciliation;
